import React from 'react';

class DocumentTitleStack {
  requests: {
    id: string;
    title: string;
  }[] = [];
  readonly initialTitle = 'Relume';

  update() {
    document.title =
      this.requests[this.requests.length - 1]?.title ?? this.initialTitle;
  }
}

const documentTitleStack = new DocumentTitleStack();

export function useDocumentTitle(title: string) {
  const id = React.useId();
  React.useEffect(() => {
    documentTitleStack.requests.push({ id, title });
    documentTitleStack.update();
    return () => {
      documentTitleStack.requests = documentTitleStack.requests.filter(
        (request) => request.id !== id,
      );
      documentTitleStack.update();
    };
  }, [id, title]);
}
